import { useNavigate } from 'react-router-dom';

const formatDistance = (distanceKm) => {
  if (!Number.isFinite(Number(distanceKm))) return '';
  const rounded = Number(distanceKm) >= 10 ? Math.round(Number(distanceKm)) : Number(distanceKm).toFixed(1);
  return `${rounded} km away`;
};

const formatDateTime = (value) => {
  if (!value) return 'Time TBD';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return 'Time TBD';
  return parsed.toLocaleString();
};

const NearbyMatchCard = ({ match, isLive = false }) => {
  const navigate = useNavigate();

  const openMatch = () => {
    if (match?.tournamentId && match?.id) {
      navigate(`/public/tournaments/${match.tournamentId}/matches/${match.id}`);
    }
  };

  return (
    <article className="card border-0 shadow-sm h-100 nearby-card">
      <div className="card-body d-flex flex-column gap-2">
        <div className="d-flex justify-content-between align-items-start gap-2">
          <h3 className="h6 mb-0">{match?.team1 || 'Team A'} vs {match?.team2 || 'Team B'}</h3>
          <span className={`badge ${isLive ? 'text-bg-danger' : 'text-bg-primary'}`}>{isLive ? 'LIVE' : 'UPCOMING'}</span>
        </div>
        <p className="mb-0 text-muted small">{match?.tournamentName || 'Local match'}</p>
        <p className="mb-0 small">{match?.venueName || match?.city || 'Venue not set'}</p>
        <p className="mb-0 text-muted small">{formatDateTime(match?.startTime)}</p>

        <div className="d-flex justify-content-between align-items-center mt-auto pt-2">
          <span className="badge text-bg-light nearby-distance">{formatDistance(match?.distanceKm)}</span>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={openMatch} disabled={!match?.tournamentId || !match?.id}>
            View Match
          </button>
        </div>
      </div>
    </article>
  );
};

export default NearbyMatchCard;
